/* Polyfills */
// TODO: Probably should use cart-js-pure and do not pollute global namespace
/* Modules */
import * as Sentry from "@sentry/browser"
import "core-js/stable/array/includes"
import "core-js/stable/dom-collections/for-each"
import "core-js/stable/number"
import "core-js/stable/object/assign"
import "mdn-polyfills/CustomEvent"
import "mdn-polyfills/Element.prototype.closest"
import "mdn-polyfills/Element.prototype.matches"
import Cart from "./modules/cart"
import CartInput from "./modules/cart-input"
import initEventListeners from "./modules/eventListeners"
import { toFraction } from "./modules/helpers"
import { cartJson, fqa, themeName } from "./modules/liquidInit"
import {
  localStorageIsAvailable,
  updateCartLocalStorage,
  updateLocalStorageIfNewOrChanged,
} from "./modules/localstorage"
import ProductInput from "./modules/product-input"

Sentry.init({
  environment: ENV,
  dsn: "https://e8bfda75f844432fa086b44dd0f0d9ea@sentry.io/1479672",
})

window._fsaLocalStorageIsAvailable = localStorageIsAvailable()

Sentry.configureScope((scope) => {
  scope.setTag("Customer Theme", themeName)
  scope.setTag("Customer Name", window.Shopify.shop)
  scope.setTag("Local Storage Available", window._fsaLocalStorageIsAvailable)
  scope.setExtra("Cart", cartJson)
})

updateLocalStorageIfNewOrChanged()

initEventListeners()

Cart.enableUpdateAndCheckoutButtons()

export const checkout = () => {
  console.warn("[FabricShop.checkoutFromAnyPage]")
  Cart.checkoutFromAnyPage()
}

export const updateItem = (item) => {
  console.warn("[FabricShop.updateItem]")
  ProductInput.updateAfterAddToCart(item)
}

export const updateCart = (cart) => {
  console.warn("[FabricShop.updateCart]")
  updateCartLocalStorage(cart)
  CartInput.updateAfterLocalStorageChange(cart)
}

export const returnQuantity = (item, qty) => {
  console.warn("[FabricShop.returnQuantity]")
  if (fqa.product && fqa.product[item.product_type]) {
    const fqty = qty / fqa.product[item.product_type].multiplier
    return toFraction(fqty)
  }
  return qty
}

export const returnItemMultiplier = (item) => {
  let multiplier = 1
  if (fqa.product && fqa.product[item.product_type]) {
    multiplier = fqa.product[item.product_type].multiplier
  }
  return multiplier
}

export const returnProductMultiplier = (product) => {
  let multiplier = 1
  if (fqa.product && fqa.product[product.type]) {
    multiplier = fqa.product[product.type].multiplier
  }
  return multiplier
}

/* global BUILD_TIMESTAMP, ENV, VERSION */
// Add build timestamp console.log to developer builds
console.log(
  `🛠️ FQA Developer Build: ${Math.round(
    (Date.now() - BUILD_TIMESTAMP) / 1000
  )} seconds ago`
)

// Version info
console.log({
  ENV,
  VERSION,
})

// App info
console.info(
  "\n\n🚀 Fabric Shop App by Sew Much Commerce\nLearn more at https://sewmuchcommerce.com/\n\n\n"
)
